import React, { useContext, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { observer } from "mobx-react-lite";
import { Segment, Dropdown } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";

interface IProps {
  id: string;
}

let data = [{ date: "", invoices: null, debitNotes: null, creditNotes: null }];
const Sales: React.FC<IProps> = ({ id }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    salesFilterOptions,
    valueSalesFilter,
    client,
    getFirstYearOfBilling,
    getGraphDataYearSuccessDocuments,
    sales,
  } = rootStore.clienStore;

  useEffect(() => {
    getFirstYearOfBilling(id);
  }, [getFirstYearOfBilling, id]);

  data = sales;

  return (
    <Segment clearing>
      <div>
        <div className="graphictitle">
          <p>Documentos electrónicos exitosos de {client?.name}</p>
        </div>
        <div className="graphicfilter">
          <Dropdown
            className="floatright"
            selection
            options={salesFilterOptions}
            onChange={(e, data) =>
              getGraphDataYearSuccessDocuments(data.value, id)
            }
            defaultValue={valueSalesFilter}
          />
        </div>
      </div>
      <div className="graphicontwithoutpadd">
        <ResponsiveContainer minHeight={300}>
          <LineChart
            data={data}
            margin={{
              top: 10,
              right:1,
              left: 1,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis width={150} />
            <Tooltip
              labelFormatter={() => {
                return "";
              }}
              formatter={(value) => {
                return [`$${value}`];
              }}
            />
            <Legend />
            <Line
              legendType="line"
              type="monotone"
              dataKey="invoices"
              stroke="blue"
              fill="#8884d8"
              name="Facturas"
            />
            <Line
              legendType="line"
              type="monotone"
              dataKey="debitNotes"
              stroke="red"
              fill="#8884d8"
              name="Notas crédito"
            />
            <Line
              legendType="line"
              type="monotone"
              dataKey="creditNotes"
              stroke="orange"
              fill="#8884d8"
              name="Notas Débito"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Segment>
  );
};
export default observer(Sales);
